// © 2026 Buddy Media LLC. All rights reserved.
import type { HTMLAttributes, PropsWithChildren } from "react";
import { cn } from "@/lib/cn";

export function AdminCard({
  children,
  className,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={cn(
        "rounded-2xl border p-5",
        className,
      )}
      style={{
        borderColor: "var(--bw-border)",
        background: "var(--bw-surface)",
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
